<script>
import mixins from '@services/notification/notifications-mixin'

export default {
  name: 'NotificationItem',
  mixins: [mixins],
  props: {
    notify: {
      type: Object,
      default: () => {
        return Object
      },
    },
  },
  data() {
    return {
      timeout: null,
    }
  },
  computed: {
    message() {
      let message = this.notify.message
      if (message.includes('Goods with DrumOil')) {
        const error = message
          .replace('Goods with ', '')
          .split(' already exists ')
        message = this.$t('error__goods_with_drumoil_already_exists', {
          '0': error[0].replace('DrumOil', ''),
          '1': error[1],
        })
      }
      if (message === 'Volume of drumOil great of drum volume.') {
        message = this.$t('error__volume_of_drumoil_great_of_drum_volume')
      }
      if (message === 'message_can_not_delete_object_by_ref') {
        message = this.$t('error__cantDeleteItem')
      }
      if (message === 'message_doc_spec_serial_exists') {
        message = this.$t('error__serialNumberExist')
      }
      if (message === 'access_denied') {
        message = this.$t('message_call_admin')
      }
      if (message === 'error__customer_number_already_exists') {
        message = this.$t('error__customer_number_already_exists')
      }
      return message
    },
  },
  mounted() {
    if (this.notify.duration === -1) {
      return
    }
    this.timeout = setTimeout(() => {
      this.$store.commit('notifications/DELETE', this.notify.id)
    }, this.notify.duration || 5000)
  },
  methods: {
    deleteItem() {
      clearTimeout(this.timeout)
      this.$store.commit('notifications/DELETE', this.notify.id)
    },
    clickHandler() {
      if (this.notify.userId) {
        this.$store.dispatch('userNotifications/markRead', this.notify.id)
      }
      this.doAction(this.notify)
    },
  },
}
</script>

<template>
  <v-alert
    v-if="notify.userId"
    :value="true"
    :class="$style.notifyItem"
    type="warning"
    color="orange"
    transition="slide-y-reverse-transition"
    icon="notifications_active"
    class="pb-2 pt-1"
    @click="deleteItem">
    <v-layout
      class="align-center"
      row>
      <v-flex md11>
        {{ $t(message) }}
      </v-flex>
      <v-flex>
        <v-btn
          small
          color="blue-grey"
          class="white--text"
          @click="clickHandler">View</v-btn>
      </v-flex>
    </v-layout>
  </v-alert>
  <v-alert
    v-else
    :value="true"
    :type="notify.type"
    :class="$style.notifyItem"
    transition="slide-y-reverse-transition"
    @click="deleteItem">
    {{ $t(message) }}
  </v-alert>
</template>

<style lang="scss" module>
@import '@design';
.notifyItem {
  cursor: pointer;
}
</style>
